export enum Branding {
    RIPPLE = 'ripple',
    HRP = 'hiddenroad',
}
